/* eslint-disable no-magic-numbers */
import { createRef } from 'preact';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { getImageUrl, onErrorImage } from '../../helpers/images';

import styleSheet from './styles/prediction.module.scss';
import styleSheetPoll from '../../components/Polling/poll.module.scss';
import { useTranslation } from 'react-i18next';
import { getPercentageAsString } from '../predictions.helper';

const styles = styleSheet.locals || {};
const stylesPoll = styleSheetPoll.locals || {};

/**
 * Component for a single prediction option
 *
 * @param {object} props prediction option props
 * @param {object} props.option prediction option data
 * @param {string} props.transitionState transition state
 * @param {number} props.optionsVisibleDelay delay for visibility transition
 * @param {boolean} props.isSelected if option is selected by user
 * @param {Function} props.onSelect callback when option has been selected by user
 * @returns {Function} <PredictionOption />
 */
function PredictionOption({
    option,
    transitionState,
    optionsVisibleDelay,
    isSelected,
    onSelect
}) {
    const { t } = useTranslation();
    const optionTextRef = createRef();
    const hasOptionImages =
        option.image_url ||
        option.external_image_url ||
        option.image_data_preview;
    const barTransitionStyles = {
        entered: { maxWidth: '100%' }
    };

    const imageUrl = option?.image_url || option?.external_image_url;

    const isAutomatedImg = option?.external_image_url && !option?.image_url;

    // const changeEditableData = (field, value) => {
    //     onPreviewEditChange?.({
    //         questions: [
    //             {
    //                 options: [{ ...option, [field]: value }]
    //             }
    //         ]
    //     });
    // };

    // useEffect(() => {
    //     if (isPreview) {
    //         enableEditableContent(
    //             optionTextRef.current,
    //             'text',
    //             changeEditableData
    //         );
    //     }
    // }, []);

    if (!option) {
        return '';
    }

    return (
        <button
            data-cy={`predictions-${option?.text}`}
            part={classNames('predictor-option', {
                'predictor-option-selected': isSelected,
                'predictor-option-with-image': hasOptionImages
            })}
            className={classNames(
                stylesPoll.pollOption,
                styles.predictionOption,
                {
                    [stylesPoll.pollOptionSelected]: isSelected
                }
            )}
            title={option.text}
            onClick={() => onSelect(option)}
        >
            <div
                className={styles.predictionOptionContent}
                part="predictor-option-content"
            >
                {hasOptionImages && (
                    <div
                        part="predictor-option-image-wrap"
                        className={classNames(styles.predictionOptionImg, {
                            [styles.predictionOptionImgAutomated]:
                                isAutomatedImg
                        })}
                    >
                        <img
                            src={getImageUrl(imageUrl, 444)}
                            onError={onErrorImage}
                            part="predictor-option-image"
                        />
                    </div>
                )}

                <div
                    className={styles.predictionOptionTitle}
                    part="predictor-option-label"
                    // {...editableAttr}
                    ref={optionTextRef}
                >
                    {option.text}
                </div>
            </div>

            <div
                data-cy="percentageValue"
                className={styles.predictionOptionPercentage}
                part="predictor-option-metrics"
            >
                <div
                    className={stylesPoll.pollOptionBar}
                    part="predictor-option-progress"
                    style={{
                        width: `${option.percentage}%`,
                        ...barTransitionStyles[transitionState],
                        transitionDelay: `${optionsVisibleDelay}ms`
                    }}
                />
                <div className={styles.predictionOptionPercentage}>
                    <span>{getPercentageAsString(option.percentage)}</span>
                    &nbsp;
                    {t('predictions.percentagePicked')}
                </div>
            </div>
        </button>
    );
}

PredictionOption.propTypes = {
    option: PropTypes.object.isRequired,
    optionCls: PropTypes.object,
    showingResults: PropTypes.bool,
    transitionStyles: PropTypes.object,
    transitionState: PropTypes.string,
    optionsVisibleDelay: PropTypes.number,
    isSelected: PropTypes.bool,
    isAnswered: PropTypes.bool,
    onSelect: PropTypes.func,
    optionImageWidth: PropTypes.number.isRequired
};

export default PredictionOption;
